$(document).ready(function() {
    if ($(window).width() <= 575) { // Check if screen width is 575px or less
        $('.merchandise-collection .card__media').each(function() {
            let $media = $(this);
            if ($media.find('.card__badge').text().trim() === "Sold out") {
                $media.find('.quick-add').hide();
            }
        });
    }

    // Function to detect if the device is a mobile device
    function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    // If it's a mobile device, use click/tap events; otherwise, use hover
    if (isMobileDevice()) {
        // Click/tap handling for mobile devices
        $('.hover.ingredients-panel').on('click tap', function() {
            var $panel = $(this);
            if ($panel.hasClass('flip')) {
                $panel.removeClass('flip');
            } else {
                $panel.addClass('flip');
            }
        });

        // Optional: Close panel when tapping outside of it (clicking on body)
        $('body').on('click tap', function(event) {
            if (!$(event.target).closest('.hover.ingredients-panel').length) {
                $('.hover.ingredients-panel').removeClass('flip');
            }
        });
    } else {
        // Hover handling for desktop devices
        $('.hover.ingredients-panel').hover(function() {
            $(this).addClass('flip');
        }, function() {
            $(this).removeClass('flip');
        });
    }


    // About us manifesto part
    AOS.init();

    const panels = document.querySelectorAll(".panel");
    let lastPanelId = ""; // To keep track of the last panel displayed

    var boxes = gsap
        .timeline({
            scrollTrigger: {
                trigger: ".sticky-container",
                pin: true,
                start: "top top",
                end: "+=2000",
                // end: "bottom bottom",
                pin: true,
                scrub: 0.3,
                onUpdate: (self) => {
                    // Calculate which panel is currently being displayed
                    var progress = self.progress;
                    var currentIndex = Math.floor(progress * panels.length);

                    // Ensure the index is within the bounds
                    currentIndex = Math.min(currentIndex, panels.length - 1);

                    // Get the ID of the currently displayed panel
                    var currentPanelId = panels[currentIndex].id;

                    // Check if the panel has changed
                    if (currentPanelId !== lastPanelId) {
                        gsap.fromTo("#div1,#div2,#div3", {
                            opacity: 0
                        }, {
                            opacity: 1,
                            duration: 0.5
                        });

                        // Select all .manifesto-icons elements
                        const manifestoIcons = document.querySelectorAll(`#${currentPanelId} .manifesto-icons`);

                        // Apply the zoom-in animation to each .manifesto-icons element
                        manifestoIcons.forEach(icon => {
                            gsap.fromTo(icon, {
                                scale: 0.5
                            }, {
                                scale: 1,
                                duration: 1
                            });
                        });
                        lastPanelId = currentPanelId;
                    }
                },
            },
            defaults: {
                duration: 0.2
            },
        })
        .to(".panel", {
            autoAlpha: 1,
            stagger: 1
        })

        .to({}, {
            duration: 1
        });

    var url = 'http://www.instagram.com/findmyhue'; // Define the URL
    $('.instagram-post-img').click(function(e) {
        e.preventDefault(); // Prevent the default link behavior
        // Open the URL in a new tab
        window.open(url, '_blank');
    });

});
if (typeof observer === "undefined") {
    const observer = new MutationObserver(() => {
        $('button[role="checkbox"] .gf-label, li.selected-item.gf-option-label .gf-label').each(function() {
            if ($(this).text().trim() === "Out of Stock") {
                $(this).text("Sold Out");
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

// Check if screen width is 767px or less
if ($(window).width() <= 767) { 
        // Handle click on .circle-reveal-btn-wrap to toggle the active class
        $('.circle-reveal-btn-wrap').on('click', function(event) {
            event.stopPropagation(); // Prevent the click from bubbling up to the document

            // If the clicked button already has the 'active' class, remove it
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('h3').css('display', 'block'); // Show h3 when not active
            } else {
                // Remove the 'active' class from all buttons and reset their h3 elements
                $('.circle-reveal-btn-wrap').removeClass('active');
                $('.circle-reveal-btn-wrap h3').css('display', 'block'); // Show all h3 elements

                // Now toggle the 'active' class on the clicked button
                $(this).addClass('active');
                $(this).find('h3').css('display', 'none'); // Hide h3 when active
            }

            console.log('Button clicked, active class toggled.');
        });

        // Close the circle-reveal-btn-wrap when clicking outside
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.circle-reveal-btn-wrap').length) {
                // Clicked outside, so remove the active class from all buttons
                $('.circle-reveal-btn-wrap').removeClass('active');
                $('.circle-reveal-btn-wrap h3').css('display', 'block'); // Show all h3 elements
            }
        });
    }